import React from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material'
import PropTypes from 'prop-types'

import orbitLight from '../../../assets/brand/orbit/orbitLight.svg'

export default function OnboardingTourModal({
  isOnboardModalOpen,
  setIsOnboardModalOpen,
  userName,
  handleStartOnboarding
}) {
  return (
    <Dialog
      open={isOnboardModalOpen}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: 'neutrals.800'
        }}
      >
        <Box>
          <img src={orbitLight} />
        </Box>
      </Box>

      <DialogTitle>
        <strong>Hello {userName}, welcome to Orbit!</strong>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Would you like to take a short tour of the Orbit platform?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          display='flex'
          variant='secondary'
          sx={{ height: '50px' }}
          onClick={() => setIsOnboardModalOpen(false)}
          autoFocus
        >
          No
        </Button>
        <Button
          variant='filled'
          sx={{
            display: 'flex',
            height: '50px'
          }}
          onClick={handleStartOnboarding}
          autoFocus
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  )
}

OnboardingTourModal.propTypes = {
  isOnboardModalOpen: PropTypes.bool,
  setIsOnboardModalOpen: PropTypes.func,
  userName: PropTypes.string,
  handleStartOnboarding: PropTypes.func
}
